(() => {
  class CustomSearchDrawer extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.container = document.getElementById("Custom-Search-Drawer");
      this.form = this.container.querySelector("form.searchform");
      this.input = this.container.querySelector('input[type="search"]');
      this.contentWrapper = this.container.querySelector("[data-predictive-search-content]");
      this.predictiveSearchResults = this.querySelector("[data-predictive-search]");
      this.predictiveSearchLink = this.querySelector(".custom-search-drawer__promo-link");
      this.promoHeading = this.querySelector("[data-promo-heading]");
      this.promotionContainer = this.querySelector("[data-promotions]");
      this.loadingOverlay = this.querySelector(".loading-overlay");

      if (this.predictiveSearchLink) {
        this.originalHref = this.predictiveSearchLink.getAttribute("data-original-href") || this.predictiveSearchLink.href;
        this.originalText = this.predictiveSearchLink.getAttribute("data-original-text") || this.predictiveSearchLink.textContent;
        this.searchResultText = this.predictiveSearchLink.getAttribute("data-search-result-text") || "View all results";
      }

      if (this.promoHeading) {
        this.originalHeading = this.promoHeading.getAttribute("data-original-heading") || this.promoHeading.textContent;
        this.searchResultsHeading = this.promoHeading.getAttribute("data-search-results-heading") || "Search results";
      }

      this.openButtons = document.querySelectorAll(".thb-quick-search");
      this.clickCapture = document.querySelector(".click-capture");
      this.closeButton = this.querySelector("[data-predictive-search-close]");
      this.handleToggleClick = this.toggleSearchDrawerClick.bind(this);
      this.isOpen = false;
      this.setupEventListeners();
    }

    setupEventListeners() {
      this.openButtons.forEach((item) => {
        item.addEventListener("click", this.handleToggleClick);
      });

      this.closeButton.addEventListener("click", this.handleToggleClick);
      this.clickCapture.addEventListener("click", this.handleCaptureClick.bind(this));
      this.input.addEventListener(
        "input",
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
      this.form.addEventListener("submit", this.onFormSubmit.bind(this));
    }

    onFormSubmit(event) {
      if (!this.getQuery().length) {
        event.preventDefault();
      }
    }

    onChange() {
      const searchTerm = this.getQuery();
      if (!searchTerm.length) {
        this.showPromotions();
        this.restoreOriginalLink();
        return;
      }
      this.predictiveSearchResults.classList.add("active");
      this.promotionContainer.classList.add("hidden");
      this.getSearchResults(searchTerm);
    }

    showPromotions() {
      this.predictiveSearchResults.classList.remove("active");
      this.promotionContainer.classList.remove("hidden");
      this.restoreOriginalHeading();
    }

    restoreOriginalLink() {
      if (this.predictiveSearchLink && this.originalHref && this.originalText) {
        this.predictiveSearchLink.href = this.originalHref;
        this.predictiveSearchLink.textContent = this.originalText;
      }
    }

    restoreOriginalHeading() {
      if (this.promoHeading && this.originalHeading) {
        this.promoHeading.textContent = this.originalHeading;
      }
    }

    updateSearchHeading(searchTerm) {
      if (this.promoHeading && this.searchResultsHeading) {
        this.promoHeading.textContent = `${this.searchResultsHeading} (${searchTerm})`;
      }
    }

    updateSearchLink(searchTerm) {
      if (this.predictiveSearchLink && this.searchResultText) {
        const searchUrl = `${theme.routes.search_url}?q=${encodeURIComponent(searchTerm)}`;
        this.predictiveSearchLink.href = searchUrl;
        this.predictiveSearchLink.textContent = this.searchResultText;
      }
    }

    getSearchResults(searchTerm) {
      const queryKey = searchTerm.replace(" ", "-").toLowerCase();

      this.predictiveSearchResults.classList.add("loading");
      if (this.loadingOverlay) {
        this.loadingOverlay.classList.add("active");
      }

      fetch(
        `${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent(
          "resources[type]"
        )}=product,article,query&${encodeURIComponent(
          "resources[limit]"
        )}=10&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku&section_id=custom-predictive-search`
      )
        .then((response) => {
          this.predictiveSearchResults.classList.remove("loading");
          if (this.loadingOverlay) {
            this.loadingOverlay.classList.remove("active");
          }
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("#shopify-section-custom-predictive-search").innerHTML;

          this.renderSearchResults(resultsMarkup);

          this.updateSearchHeading(searchTerm);
          
          const hasResults = this.predictiveSearchResults.querySelector(".custom-search-drawer__result-list");
          if (hasResults && hasResults.children.length > 0) {
            this.updateSearchLink(searchTerm);
          } else {
            this.restoreOriginalLink();
          }
        })
        .catch((error) => {
          if (this.loadingOverlay) {
            this.loadingOverlay.classList.remove("active");
          }
          this.restoreOriginalLink();
          throw error;
        });
    }

    getQuery() {
      return this.input.value.trim();
    }

    renderSearchResults(resultsMarkup) {
      this.predictiveSearchResults.innerHTML = resultsMarkup;

      const event = new CustomEvent('predictive-search:results-rendered', {
        detail: { resultsMarkup: resultsMarkup }
      });
      window.dispatchEvent(event);
      this.predictiveSearchLink = this.predictiveSearchResults.querySelector(".custom-search-drawer__promo-link");
      this.promoHeading = this.predictiveSearchResults.querySelector("[data-promo-heading]");

      if (this.predictiveSearchLink) {
        this.originalHref = this.predictiveSearchLink.getAttribute("data-original-href") || this.originalHref;
        this.originalText = this.predictiveSearchLink.getAttribute("data-original-text") || this.originalText;
        this.searchResultText = this.predictiveSearchLink.getAttribute("data-search-result-text") || this.searchResultText;
      }

      if (this.promoHeading) {
        this.originalHeading = this.promoHeading.getAttribute("data-original-heading") || this.originalHeading;
        this.searchResultsHeading = this.promoHeading.getAttribute("data-search-results-heading") || this.searchResultsHeading;
      }
    }

    handleCaptureClick(event) {
      if (this.isOpen) {
        this.toggleSearchDrawerClick(event);
      }
    }

    toggleSearchDrawerClick(event) {
      event.preventDefault();
      this.classList.toggle("active");
      document.getElementsByTagName("body")[0].classList.toggle("open-sc");

      if (this.classList.contains("active")) {
        this.isOpen = true;
        setTimeout(() => {
          this.input.focus({
            preventScroll: true,
          });
        }, 100);
      } else {
        this.isOpen = false;
        this.input.value = '';
        this.showPromotions();
        this.restoreOriginalLink();
      }
    }
  }

  if (!customElements.get("predictive-search")) {
    customElements.define("predictive-search", CustomSearchDrawer);
  }
})();
